import React,{useEffect} from 'react';
import Header from './Header';
function App() {
  // useEffect(() => {
  //   let abhi = document.getElementById('geocoder')
  //   abhi.classList.add('disableMenu')
  // }, [])
  // console.log(abhi);
  // abhi.classList.add('disableMenu')
  return (
    // <Router>
    // <div>
        <Header />
    //   <Switch>
    //     <Route path='/maps'>
    //       <Map />
    //     </Route>
    //     <Route path='/maps2'>
    //       <Map2 />
    //     </Route>
    //     <Route path='/'>
    //     {/* {abhi.classList.remove('disableMenu')} */}
    //   <SearchFrame />
    //     </Route>
    //   </Switch>
    // </div>
    // </Router>
      
  )
}
export default App
